import React from "react";
import {
    SlideshowDot,
    StyledSlideshow,
    StyledSlideshowSlider,
    SlideshowDots,
    StyledSlide,
    OverlayContainer,
    OverlayButtonContainer,
    OverlayButton,
} from "./SlideShow.styles";

const slideshowTimer = 5000; //in miliseconds

export const Slideshow = ({children, useParentWidth}) => {
    const [index, setIndex] = React.useState(0);
    const timeoutRef = React.useRef(null);
    const [ carouselWrapper, setCarouselWrapper] = React.useState(null);
    const carouselWrapperWidth = carouselWrapper ? carouselWrapper.offsetWidth + 'px' : '1120px';

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    React.useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(() =>
            setIndex((prevIndex) =>
                prevIndex >= children.length - 1 ? 0 : prevIndex + 1
            ), slideshowTimer);
        return () => {
            resetTimeout();
        };
    }, [index]);

    React.useEffect(()=>{
        setCarouselWrapper( document.getElementById( 'marweb-styled-carousel' ));
    });


    return (
        <StyledSlideshow id={"marweb-styled-carousel"}
            numberOfChildren={ children.length }
            useParentWidth={useParentWidth}
            parentWidth={carouselWrapperWidth}
        >
            <StyledSlideshowSlider
                index={ index }
                numberOfChildren={children.length}
                useParentWidth={useParentWidth}
                parentWidth={carouselWrapperWidth}
            >
                {
                    children.map((child, i) => <StyledSlide
                        key={i}
                        numberOfChildren={children.length}
                        useParentWidth={useParentWidth}
                        parentWidth={carouselWrapperWidth}
                        // active={index === i}
                    >{child}</StyledSlide>)
                }
            </StyledSlideshowSlider>
            <OverlayContainer>
                <OverlayButtonContainer
                    position={"left"}
                    onClick={() => {
                        if (index <= 0) {
                            setIndex(children.length - 1);
                        } else {
                            setIndex(index - 1);
                        }
                    }}
                >
                        <svg className="carousel-arrow" height="30" width="30" viewBox="0 0 30 30">
                          <line x1="20" y1="5" x2="10" y2="15" stroke="#CACACA" stroke-width="7" stroke-linecap="round"></line>
                          <line x1="10" y1="15" x2="20" y2="25" stroke="#CACACA" stroke-width="7" stroke-linecap="round"></line>
                        </svg>
                </OverlayButtonContainer>
                <OverlayButtonContainer
                    position={"right"}
                    onClick={() => {
                        if (index >= children.length - 1) {
                            setIndex(0);
                        } else {
                            setIndex(index + 1);
                        }
                    }}
                >
                        <svg className="carousel-arrow" height="30" width="30" viewBox="0 0 30 30">
                          <line x1="10" y1="5" x2="20" y2="15" stroke="#CACACA" stroke-width="7" stroke-linecap="round"></line>
                          <line x1="20" y1="15" x2="10" y2="25" stroke="#CACACA" stroke-width="7" stroke-linecap="round"></line>
                        </svg>
                </OverlayButtonContainer>
            </OverlayContainer>
            <SlideshowDots>
                {children.map((_, idx) => (
                    <SlideshowDot
                        key={idx}
                        active={index === idx}
                        onClick={() => {
                            setIndex(idx);
                        }}
                    />
                ))}
            </SlideshowDots>
        </StyledSlideshow>
    );
}
